module.exports = __webpack_public_path__ + "static/media/M&MFIN_F1.950080a6.txt";